/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyJob } from '../models/CompanyJob';
import type { CompanyJobCategory } from '../models/CompanyJobCategory';
import type { CompanyJobFamily } from '../models/CompanyJobFamily';
import type { CompanyJobFamilySort } from '../models/CompanyJobFamilySort';
import type { CompanyJobGlobalGrade } from '../models/CompanyJobGlobalGrade';
import type { CompanyJobLevel } from '../models/CompanyJobLevel';
import type { CompanyLocation } from '../models/CompanyLocation';
import type { CreateDraftJobRequest } from '../models/CreateDraftJobRequest';
import type { JobDataMappedFilter } from '../models/JobDataMappedFilter';
import type { JobMappingMode } from '../models/JobMappingMode';
import type { LevelMappingMappedFilter } from '../models/LevelMappingMappedFilter';
import type { Paymarket } from '../models/Paymarket';
import type { Plan } from '../models/Plan';
import type { Survey } from '../models/Survey';
import type { SurveyJobCompanyJobMappingCommentsInfo } from '../models/SurveyJobCompanyJobMappingCommentsInfo';
import type { SurveyJobCompanyJobMappingStatus } from '../models/SurveyJobCompanyJobMappingStatus';
import type { SurveyJobDefinition } from '../models/SurveyJobDefinition';
import type { Tag } from '../models/Tag';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class JobdataService {

    /**
     * Returns the list of company jobs
     * @returns any Success
     * @throws ApiError
     */
    public static getCompanyJobList({
        requestBody,
    }: {
        requestBody: {
            planId?: number;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            grade?: Array<string>;
            jobCategory?: Array<number>;
            surveyJobProfileId?: string;
            surveyModuleId?: Array<string>;
            localMappingPaymarketId?: number | null;
            jobMappingMode?: (JobMappingMode | string | null);
            active?: string;
            mapped?: JobDataMappedFilter;
            benchmark?: string;
            jobType?: string | null;
            companyJobType?: string | null;
            purchasedOnly?: boolean;
            search?: Array<string>;
            tags?: Array<number>;
            excludeSlottedJobs?: boolean;
            excludeDraftJobs?: boolean;
            excludedJob?: Array<number>;
            mappingStatus?: Array<SurveyJobCompanyJobMappingStatus>;
            companyJob?: Array<number>;
            sort?: Record<string, any>;
            limit?: number;
            offset?: number;
            ignorePagination?: boolean;
        },
    }): CancelablePromise<{
        rows: Array<CompanyJob>;
        commentsInfo?: Array<SurveyJobCompanyJobMappingCommentsInfo>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create draft company job
     * @returns CompanyJob Success
     * @throws ApiError
     */
    public static createDraftCompanyJob({
        requestBody,
    }: {
        requestBody: CreateDraftJobRequest,
    }): CancelablePromise<CompanyJob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/draft',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of company job levels
     * @returns any Success
     * @throws ApiError
     */
    public static getCompanyJobLevelList({
        plan,
        dataModelId,
        sort,
        jobCategory,
        search,
        surveyJobProfileId,
        vendorLevelProfileId,
        mapped,
        limit,
        offset,
    }: {
        plan?: number,
        /**
         * Data Model Id
         */
        dataModelId?: number,
        sort?: string,
        jobCategory?: Array<number>,
        search?: string,
        surveyJobProfileId?: string,
        vendorLevelProfileId?: string,
        mapped?: LevelMappingMappedFilter,
        limit?: number,
        offset?: number,
    }): CancelablePromise<{
        rows: Array<CompanyJobLevel>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/level',
            query: {
                'plan': plan,
                'dataModelId': dataModelId,
                'sort': sort,
                'jobCategory': jobCategory,
                'search': search,
                'surveyJobProfileId': surveyJobProfileId,
                'vendorLevelProfileId': vendorLevelProfileId,
                'mapped': mapped,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of company job global grades
     * @returns any Success
     * @throws ApiError
     */
    public static getCompanyJobGlobalGradeList({
        plan,
        search,
        surveyJobProfileId,
        vendorLevelProfileId,
        mapped,
        limit,
        offset,
    }: {
        plan?: number,
        search?: string,
        surveyJobProfileId?: string,
        vendorLevelProfileId?: string,
        mapped?: LevelMappingMappedFilter,
        limit?: number,
        offset?: number,
    }): CancelablePromise<{
        rows: Array<CompanyJobGlobalGrade>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/globalGrade',
            query: {
                'plan': plan,
                'search': search,
                'surveyJobProfileId': surveyJobProfileId,
                'vendorLevelProfileId': vendorLevelProfileId,
                'mapped': mapped,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of company job grades
     * @returns string Success
     * @throws ApiError
     */
    public static getCompanyJobGradeList(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/grade',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of company job families
     * @returns any Success
     * @throws ApiError
     */
    public static getCompanyJobFamilyList({
        sort,
        limit,
        offset,
        search,
        dataModelId,
        ignorePagination,
    }: {
        sort?: CompanyJobFamilySort,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Search
         */
        search?: string,
        /**
         * Data Model Id
         */
        dataModelId?: number,
        ignorePagination?: boolean,
    }): CancelablePromise<{
        rows: Array<CompanyJobFamily>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/family',
            query: {
                'sort': sort,
                'limit': limit,
                'offset': offset,
                'search': search,
                'dataModelId': dataModelId,
                'ignorePagination': ignorePagination,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of company job categories
     * @returns any Success
     * @throws ApiError
     */
    public static getCompanyJobCategoryList({
        sort,
    }: {
        sort?: string,
    }): CancelablePromise<{
        rows: Array<CompanyJobCategory>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/category',
            query: {
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of unique salaryStructure attributes across all company jobs
     * @returns any Success
     * @throws ApiError
     */
    public static getJobStructureList(): CancelablePromise<{
        rows?: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/structure',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Returns the list of unique FLSAStatus attributes across all company jobs
     * @returns any Success
     * @throws ApiError
     */
    public static getJobFlsaList(): CancelablePromise<{
        rows?: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/flsa',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Returns the list of company job locations
     * @returns any Success
     * @throws ApiError
     */
    public static getCompanyJobLocationList({
        plan,
    }: {
        plan?: Array<number>,
    }): CancelablePromise<{
        rows: Array<{
            country: string;
            locations?: Array<CompanyLocation>;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/location',
            query: {
                'plan': plan,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of recommendations map
     * @returns SurveyJobDefinition Success
     * @throws ApiError
     */
    public static getCompanyJobRecommendationsMap({
        surveyJobProfileId,
        companyJobs,
        surveyJobLevelId,
        surveyJobFamilyId,
        surveyJobSubFamilyId,
        surveyJobFocusId,
        plan,
        purchasedOnly,
    }: {
        surveyJobProfileId: string,
        companyJobs: Array<number>,
        surveyJobLevelId?: Array<string>,
        surveyJobFamilyId?: Array<string>,
        surveyJobSubFamilyId?: Array<string>,
        surveyJobFocusId?: Array<string>,
        plan?: number,
        purchasedOnly?: boolean,
    }): CancelablePromise<Record<string, Array<SurveyJobDefinition>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/recommendations',
            query: {
                'surveyJobProfileId': surveyJobProfileId,
                'companyJobs': companyJobs,
                'surveyJobLevelId': surveyJobLevelId,
                'surveyJobFamilyId': surveyJobFamilyId,
                'surveyJobSubFamilyId': surveyJobSubFamilyId,
                'surveyJobFocusId': surveyJobFocusId,
                'plan': plan,
                'purchasedOnly': purchasedOnly,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of unique job eligibilities attributes across all company jobs
     * @returns any Success
     * @throws ApiError
     */
    public static getCompanyJobEligibilities(): CancelablePromise<{
        jobEligibility1: Array<string>;
        jobEligibility2: Array<string>;
        jobEligibility3: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/eligibilities',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Returns the list of company job filters
     * @returns any Success
     * @throws ApiError
     */
    public static getCompanyJobFilters(): CancelablePromise<{
        companyJobs?: Array<CompanyJob>;
        companyJobsFiltered?: Array<CompanyJob>;
        grades?: Array<{
            grade?: string;
        }>;
        jobFamilies?: Array<CompanyJobFamily>;
        jobFamiliesFiltered?: Array<CompanyJobFamily>;
        jobLevels?: Array<CompanyJobLevel>;
        paymarkets?: Array<Paymarket>;
        plans?: Array<Plan>;
        surveys?: Array<Survey>;
        tag?: Array<Tag>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/filters',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the Last Company Job DataLoader
     * @returns any Success
     * @throws ApiError
     */
    public static getLastCompanyJobDataLoader({
        type,
    }: {
        /**
         * Company Job File Type
         */
        type: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/dataLoader/{type}',
            path: {
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Company Job DataLoader
     * @returns any Success
     * @throws ApiError
     */
    public static updateCompanyJobDataLoader({
        type,
    }: {
        /**
         * Company Job File Type
         */
        type: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/dataLoader/{type}',
            path: {
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Process Company Job DataLoader
     * @returns any Success
     * @throws ApiError
     */
    public static processCompanyJobDataLoader({
        type,
        requestBody,
    }: {
        /**
         * Company Job File Type
         */
        type: string,
        requestBody: {
            name?: string;
            key?: string;
            bucket?: string;
            planId?: number;
            effectiveDate?: string;
            version?: string;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/dataLoader/{type}/process',
            path: {
                'type': type,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Return company job
     * @returns CompanyJob Success
     * @throws ApiError
     */
    public static getCompanyJob({
        companyJobId,
        planId,
    }: {
        /**
         * Company Job Id
         */
        companyJobId: number,
        planId?: number,
    }): CancelablePromise<CompanyJob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/{companyJobId}',
            path: {
                'companyJobId': companyJobId,
            },
            query: {
                'planId': planId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete company jobs
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyJob({
        companyJobId,
    }: {
        /**
         * Company Job Id
         */
        companyJobId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/jobdata/{companyJobId}',
            path: {
                'companyJobId': companyJobId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update company job
     * @returns CompanyJob Success
     * @throws ApiError
     */
    public static updateCompanyJob({
        companyJobId,
        requestBody,
    }: {
        /**
         * Company Job Id
         */
        companyJobId: number,
        requestBody: {
            jobTitle?: string;
            jobCode?: string;
            jobDescription?: string;
            jobFamily?: number;
            jobLevel?: number;
            jobSubFamily?: number;
            deactivated?: boolean;
            benchmark?: boolean;
            paymarkets?: Array<number>;
        },
    }): CancelablePromise<CompanyJob> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/jobdata/{companyJobId}',
            path: {
                'companyJobId': companyJobId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
